import React, {Component} from 'react';
import '../../local_node_modules/react-select/dist/react-select.css';
import {Col, Row} from 'reactstrap';
import Select from "../../local_node_modules/react-select"
import DefaultModal from "../invoice/DefaultModal";
import moment from "moment";
import Datetime from "react-datetime";
import {request} from "../../helper/APIUtils";
import {showAxiosError} from "../../helper/helper";
import TextOverFlowTooltip from "../../components/TextOverFlowTooltip";
import Alert from "react-s-alert";
import NumberFormat from "react-number-format";
import {defterUnitName} from "../../helper/permission";
import {EntegratorConf} from "../../constants";

class HakedisModal extends Component {

	constructor(props) {
		super(props);
		this.state = {
			saveDisabled:false,
			paymentMonitoring: null,
			disabled:false,
			loading:false,
			distributorId:null,
			selectedIndex:null,
			startDate: moment(Datetime.moment()).startOf('month').format("YYYY-MM-DD"),
			finishDate:moment(Datetime.moment()).format("YYYY-MM-DD"),
			includeGift:null,

		};
		this.onChangeDate = this.onChangeDate.bind(this);
		this.calculate 	  = this.calculate.bind(this);
		this.save 	  	  = this.save.bind(this);
		this.includeBox   = this.includeBox.bind(this);
	}

	onChangeDate(name,momentObj){
		if (!(typeof momentObj === "string")) {
			this.setState({[name]: momentObj.format("YYYY-MM-DD")});
		}
	}

	calculate(){
		let self = this;
		let {startDate,finishDate,distributorId,includeGift}=self.state;
		includeGift = includeGift ? includeGift : false;
		let params = {
			url: `/progresspayment/calculate`,
			method: "post",
			data:{
				startDate,
				finishDate,
				distributorId,
				includeGift
			}
		};
		self.setState({loading:true,paymentMonitoring:null});
		request(params)
		.then(function (response) {
			console.log("data",response.data);
			let paymentMonitoring = response.data;
			self.setState({paymentMonitoring, loading:false});
		}).catch(function (error) {
			self.setState({loading:false});
			showAxiosError(error);
		});
	}

	save(){
		let self = this;
		let params = {
			url: `/progresspayment/save`,
			method: "post",
			data:self.state.paymentMonitoring
		};
		self.setState({saveDisabled:true});
		request(params)
		.then(function (response) {
			self.setState({saveDisabled:false});
			Alert.success(response.data, {
				position: 'top-right',
				effect: 'stackslide',
				timeout: 5000
			});
			self.props.toggle(true);
		}).catch(function (error) {
			self.setState({saveDisabled:false});
			showAxiosError(error);
		});
	}

	getUnitType(unit){
		if(unit === 1){
			return ("Kontör");
		}else if(unit===2){
			return (defterUnitName(EntegratorConf.identifier));
		}else if(unit===3){
			return ("e-Arşiv Kasa")
		}else{
			return ("Birim Yok");
		}
	}

	getCreditAction(creditAction){
		if(creditAction === 0){
			return ("Sıfır Başlangıç");
		}else if(creditAction===1){
			return ("Satın Alma");
		}else if(creditAction===2){
			return ("Devir (Giriş)");
		}else if(creditAction===3){
			return ("Hediye")
		}else if(creditAction===4){
			return ("Devir (Çıkış)")
		}else if(creditAction===5){
			return ("Transfer")
		}else if(creditAction===6){
			return ("Kredi Havuzuna Katılma")
		}else if(creditAction===7){
			return ("Kredi Havuzundan Ayrılma")
		}else if(creditAction===8){
			return ("Kredi Silme")
		}else{
			return ("Hareket Yok");
		}
	}

	includeBox(e){
		this.setState({includeGift:e.target.checked})
	}

	render() {
		let {paymentMonitoring} =this.state;
		return (
			<DefaultModal
				disabled={this.state.saveDisabled}
				isOpen={this.props.show}
				title="Hakediş Hesaplama"
				size="xl"
				confirmBtnText="Kaydet"
				cancelBtnText="Kapat"
				onCancel={() => this.props.toggle(false)}
				onConfirm={this.save}>
				<Col sm="12">
					<Col sm="12" style={{border: "2px solid #e7e7e7", borderRadius: "6px 6px 6px 6px"}}>
						<Row style={{marginBottom: "20px" ,marginTop: "6px"}}>
							<Col sm="2" lg="2">
								<Datetime locale="tr"
										  className="datepicker"
										  input={true}
										  inputProps={{id: 'startDate'}}
										  closeOnSelect={true}
										  value={moment(this.state.startDate)}
										  defaultValue={moment()}
										  dateFormat="DD-MM-YYYY"
										  timeFormat={false}
										  isValidDate={function (current) {
											  return current.isBefore(Datetime.moment());
										  }}
										  onChange={(e) => this.onChangeDate("startDate",e)}/>
							</Col>
							<Col sm="2" lg="2">
								<Datetime locale="tr"
										  className="datepicker"
										  input={true}
										  inputProps={{id: 'finishDate'}}
										  closeOnSelect={true}
										  value={moment(this.state.finishDate)}
										  defaultValue={moment()}
										  dateFormat="DD-MM-YYYY"
										  timeFormat={false}
										  isValidDate={function (current) {
											  return current.isBefore(Datetime.moment());
										  }}
										  onChange={(e) => this.onChangeDate("finishDate",e)}/>
							</Col>
							<Col sm="3" lg="3">
								<Select
									value={this.state.distributorId}
									clearable={false}
									placeholder="Seçiniz..."
									onChange={(e)=> e && this.setState({distributorId: e.value})}
									options={this.props.distributors}
								/>
							</Col>
							<Col sm="3" lg="3">
								<label htmlFor="includeGift">
									<input type="checkbox"
									   id="includeGift" name="includeGift"
									   checked={this.state.includeGift}
									   onChange={this.includeBox}/>
									   <span> Hediyeleri Dahil Et</span>
								</label>
							</Col>
							<Col sm="2" lg="2">
								<button type="button"
										disabled={this.state.disabled}
										className={"btn-sm btn-icon TekBtn kaydet"}
										style={{float: 'left' , padding:'9px 45px 9px 20px'}}
										onClick={this.calculate}>Hesapla
								</button>
							</Col>
						</Row>
						<div className="card-body" style={{padding: '1em 1em 1em 1em'}}>
							<div className="row">
								<div className="col-sm-12" style={{paddingRight: '5px', maxHeight:'500px', overflow:"auto"}}>
									<table className="" style={{textAlign: 'center'}}>
										<thead>
										<tr style={{backgroundColor: '#ebedf0'}}>
											<th>VKN/TCKN</th>
											<th>Ünvan</th>
											<th>Alım Tarihi</th>
											<th>Birim türü</th>
											<th>İşlem Türü</th>
											<th>Miktar</th>
											<th>Birim Fiyat</th>
											<th>Fiyat</th>
											<th>Hakediş</th>
										</tr>
										</thead>
										<tbody>
										{paymentMonitoring && paymentMonitoring.paymentMonitoringDetailList && paymentMonitoring.paymentMonitoringDetailList.map((item, index) =>
											<tr key={"item_" + index}>
												<td>{item.vknTckn}</td>
												<td> {<TextOverFlowTooltip text={item.customerName} maxLength={16}/>}</td>
												<td>{moment(item.purchaseDate).isValid() ? moment(item.purchaseDate).format("DD-MM-YYYY HH:mm:ss") : ''}</td>
												<td>{this.getUnitType(item.unit)}</td>
												<td>{this.getCreditAction(item.creditAction)}</td>
												<td>{item.purchase}</td>
												<td>{item.unitPrice}</td>
												<td>
													{<NumberFormat id={'price_' + index}
																   value={item.price}
																   disabled={true}
																   style={{ width:"64px"}}
																   isNumericString={true}
																   allowEmptyFormatting={false}
																   decimalScale={4}
																   thousandSeparator={'.'}
																   decimalSeparator={','}
																   displayType="input"
																   placeholder="Fiyat"
																   maxLength="10"
																   className="form-control"/>}
												</td>
												<td>
													{this.state.selectedIndex === index &&
														<i className="fas fa-spinner fa-spin" style={{color:"dark",paddingRight:"4px"}}/>
													}
													{this.state.selectedIndex !== index &&
															<NumberFormat  id={'calculatedPrice_' + index}
																	   value={item.calculatedPrice}
																	   disabled={true}
																	   style={{ width:"64px"}}
																	   isNumericString={true}
																	   allowEmptyFormatting={false}
																	   decimalScale={4}
																	   thousandSeparator={'.'}
																	   decimalSeparator={','}
																	   displayType="input"
																	   placeholder="Hakediş Fiyatı"
																	   maxLength="10"
																	   className="form-control"/>
													}
												</td>
											</tr>
										)}
										{!this.state.loading && (paymentMonitoring && paymentMonitoring.paymentMonitoringDetailList.length === 0) &&
										<tr>
											<td colSpan="9">Kayıt bulunamadı</td>
										</tr>
										}
										{this.state.loading &&
										<tr>
											<td colSpan="9">Kayıtlar getiriliyor...</td>
										</tr>
										}
										</tbody>
									</table>
								</div>
								<div className="col-sm-12" style={{paddingTop:'10px'}}>
									<div className="col-sm-6" style={{float:'left'}}><p style={{fontWeight:'bold', display:'inline'}}>Alım Adedi:</p> {(paymentMonitoring && paymentMonitoring.paymentMonitoringDetailList ? paymentMonitoring.paymentMonitoringDetailList.length : 0)}</div>
									<div className="col-sm-6" style={{float:'left'}}><p style={{fontWeight:'bold', display:'inline'}}>Aktif Müşteri:</p> {paymentMonitoring ? paymentMonitoring.activeCustomerCount : 0}</div>
									<div className="col-sm-6" style={{float:'left'}}><p style={{fontWeight:'bold', display:'inline'}}>Hakediş Yüzdesi(Kontör):</p> {paymentMonitoring ?  paymentMonitoring.creditPercentage*100 : 0}%</div>
									<div className="col-sm-6" style={{float:'left'}}><p style={{fontWeight:'bold', display:'inline'}}>Hakediş Yüzdesi({defterUnitName(EntegratorConf.identifier)}):</p> {paymentMonitoring ?  paymentMonitoring.storagePercentage*100 : 0}%</div>
									<div className="col-sm-6" style={{float:'left'}}><p style={{fontWeight:'bold', display:'inline'}}>Toplam Kredi Alımı:</p> {paymentMonitoring ?  paymentMonitoring.totalCreditPurchase : 0}</div>
									<div className="col-sm-6" style={{float:'left'}}><p style={{fontWeight:'bold', display:'inline'}}>Toplam {defterUnitName(EntegratorConf.identifier)} Alımı::</p> {paymentMonitoring ?  paymentMonitoring.totalStoragePurchase :0}</div>
									<div className="col-sm-6" style={{float:'left'}}><p style={{fontWeight:'bold', display:'inline'}}>Toplam Kredi Hakediş Tutarı:</p> {paymentMonitoring ?  paymentMonitoring.totalCreditAmount:0}₺</div>
									<div className="col-sm-6" style={{float:'left'}}><p style={{fontWeight:'bold', display:'inline'}}>Toplam {defterUnitName(EntegratorConf.identifier)} Hakediş Tutarı:</p> {paymentMonitoring ?  paymentMonitoring.totalStorageAmount:0}₺</div>
									<div className="col-sm-6" style={{float:'left'}}><p style={{fontWeight:'bold', display:'inline'}}>Toplam Hakediş Tutarı:</p> {paymentMonitoring ?  (paymentMonitoring.totalStorageAmount + paymentMonitoring.totalCreditAmount) : 0}₺</div>
								</div>
							</div>
						</div>
					</Col>
				</Col>
			</DefaultModal>
		);
	}
}

export default HakedisModal;

